import { render, staticRenderFns } from "./Impostos.vue?vue&type=template&id=e2f85a14&scoped=true&"
import script from "./Impostos.vue?vue&type=script&lang=js&"
export * from "./Impostos.vue?vue&type=script&lang=js&"
import style0 from "./Impostos.vue?vue&type=style&index=0&id=e2f85a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f85a14",
  null
  
)

component.options.__file = "Impostos.vue"
export default component.exports